import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useWizardFormContext } from 'components/wizard-form/context'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Typography from '@material-ui/core/Typography'

const SelectLocation = ({ isAcadEvent }) => {
  const { errors, control, watch } = useFormContext()
  const {
    extraData: { coachFacilities, coachAcademies },
  } = useWizardFormContext()

  const academyId = watch('academyId')
  const academy = coachAcademies.find(academy => academy.id === academyId)
  const academyFacilities = academy?.facilities ?? []

  const hasAcademies = coachAcademies.length >= 1
  const shouldDisplaylocationSelect =
    (isAcadEvent && academyId) || (!isAcadEvent && !academyId)

  return (
    <FormControl error={!!errors.locationId} variant="outlined" fullWidth>
      {shouldDisplaylocationSelect && (
        <>
          <InputLabel id="category">Select location</InputLabel>
          <Controller
            name="locationId"
            control={control}
            render={({ onChange, value }, _) => (
              <Select
                labelId="location"
                label="Select location"
                defaultValue={coachFacilities[0]}
                value={value || ''}
                onChange={onChange}
                data-cy={'location'}
              >
                {hasAcademies && !isAcadEvent && (
                  <MenuItem value="" disabled>
                    <Typography variant="caption">Facilities</Typography>
                  </MenuItem>
                )}
                {!isAcadEvent &&
                  coachFacilities
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((location, idx) => (
                      <MenuItem
                        key={location.id}
                        value={location.id}
                        data-cy={'facility-menu-item'}
                      >
                        {location.name}
                      </MenuItem>
                    ))}
                {isAcadEvent && (
                  <MenuItem value="" disabled>
                    <Typography variant="caption">Sections</Typography>
                  </MenuItem>
                )}
                {isAcadEvent &&
                  academyFacilities.length >= 1 &&
                  academyFacilities
                    .filter(facility => academyFacilities.includes(facility))
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((location, idx) => (
                      <MenuItem
                        key={location.id}
                        value={location.id}
                        data-cy={'academy-menu-item'}
                      >
                        {location.name}
                      </MenuItem>
                    ))}
              </Select>
            )}
          />
        </>
      )}
      {errors.locationId ? (
        <Typography variant="caption" color="error">
          Please select a location
        </Typography>
      ) : null}
    </FormControl>
  )
}

export default SelectLocation
